import React, { useEffect, useState } from 'react';
import { VertTypography } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Product/RelatedProductsCardStyles.less';
import 'Assets/styles/default/pages/product/ProductStyles.less';

// API
import { useSelector } from 'react-redux';
import * as productService from '../../../Services/Apis/Products/index';

const ModalRelatedProductDetails = ({ sku }) => {

  const dataProductGeneric = useSelector(({ ProductsGeneric }) => ProductsGeneric);
  const [product, setProduct] = useState(null);
  const Oidc = useSelector(({ oidc: data }) => data);

  useEffect(() => {
    if (sku)
      productService.getProductsGeneric(
        Oidc.user,
        sku
      ).then(e => {
        if (e === null) return;
        setProduct(e.data);
      }).catch(error => {

      })
  }, [sku]);

  useEffect(() => {
    if (dataProductGeneric.isLoaded && dataProductGeneric.productsGeneric.length) {
      const productGeneric = dataProductGeneric.productsGeneric[0];
      setProduct(productGeneric);
    }
    console.log(dataProductGeneric);
  }, [dataProductGeneric]);

  return (
    <>
      <div className="redemption-options-content">
        {
          product?.features?.some((s) => s.type === "CARACTERÍSTICAS") && (
            <>
              <div className="divider" />
              <VertTypography.Paragraph strong>
                Características Gerais
              </VertTypography.Paragraph>
            </>
          )
        }

        {
          product?.features?.filter((s) => s.type === "CARACTERÍSTICAS").map((item) => (
            <>
              <VertTypography.Paragraph strong>{item.name}:</VertTypography.Paragraph>
              <VertTypography.Paragraph >
                {item.value}
              </VertTypography.Paragraph>
            </>
          ))
        }

        {
          product?.features?.some((s) => s.type === "ESPECIFICAÇÕES TÉCNICAS") && (
            <>
              <div className="divider" />
              <VertTypography.Paragraph strong>
                Especificações Técnicas
              </VertTypography.Paragraph>
            </>
          )
        }

        <div style={{
          display: 'flex',
          flexDirection: 'column'
        }}>
          {
            product?.features?.filter((s) => s.type === "ESPECIFICAÇÕES TÉCNICAS").map((item) => (
              <>
                <VertTypography.Text strong>
                  {item.name}:
                </VertTypography.Text>
                <VertTypography.Text >
                  {item.value}
                </VertTypography.Text>
              </>
            ))
          }
        </div>

        <div className="divider" />
        <VertTypography.Paragraph strong>
          Detalhes
        </VertTypography.Paragraph>
        <VertTypography.Paragraph>
          {product?.description}
        </VertTypography.Paragraph>
      </div>
    </>
  )
}

export default ModalRelatedProductDetails;